import { AISummary } from "@radarly/models/ai";
import { DatavizTypeAI } from "@radarly/models/dataviz";
import { AIFragment } from "@radarly/models/search";
import { RadarlyAPI } from "./base";

export class AiAPI extends RadarlyAPI {
  public async getAIFocus<T extends DatavizTypeAI>(
    pid: number,
    searchFragmentAI: AIFragment & { analysis: { type: T } }
  ): Promise<AISummary<T>> {
    return await this.post<AISummary<T>>(
      `/projects/${pid}/jamy`,
      searchFragmentAI,
      true
    );
  }
}
